module.exports = __webpack_public_path__ + "img/award-off.40b2f940.png";